export default "__VITE_ASSET__BVw4A1Gf__"